// // import { v4 as uuidv4 } from "uuid";
// // import cogoToast from "cogo-toast";
// // const { createSlice } = require("@reduxjs/toolkit");

// // const cartSlice = createSlice({
// //   name: "cart",
// //   initialState: {
// //     cartItems: [],
// //   },
// //   reducers: {
// //     addToCart(state, action) {
// //       const product = action.payload;
// //       const {
// //         id,
// //         variation,
// //         selectedProductColor = null,
// //         selectedProductSize = null,
// //       } = product;

// //       const findMatchingItem = (item) => {
// //         const isSameId = item.id === id;
// //         const isSameColor = item.selectedProductColor === selectedProductColor;
// //         const isSameSize = item.selectedProductSize === selectedProductSize;

// //         if (!variation) {
// //           return isSameId;
// //         }
// //         return isSameId && isSameColor && isSameSize;
// //       };

// //       const existingItem = state.cartItems.find(findMatchingItem);

// //       if (!existingItem) {
// //         state.cartItems.push({
// //           ...product,
// //           quantity: product.quantity || 1,
// //           selectedProductColor,
// //           selectedProductSize,
// //           cartItemId: uuidv4(),
// //         });
// //       } else {
// //         state.cartItems = state.cartItems.map((item) =>
// //           findMatchingItem(item)
// //             ? {
// //                 ...item,
// //                 quantity: item.quantity + (product.quantity || 1),
// //               }
// //             : item
// //         );
// //       }

// //       cogoToast.success("Added To Cart", { position: "bottom-left" });
// //     },
// //     setCartItems: (state, action) => {
// //       state.cartItems = action.payload;
// //     },
// //     // addToCart(state, action) {
// //     //     const product = action.payload;
// //     //     console.log("Product", product);
// //     //     if(!product.variation){
// //     //         const cartItem = state.cartItems.find(item => item.id === product.id);
// //     //         if(!cartItem){
// //     //             state.cartItems.push({
// //     //                 ...product,
// //     //                 quantity: product.quantity ? product.quantity : 1,
// //     //                 cartItemId: uuidv4()
// //     //             });
// //     //         } else {
// //     //             state.cartItems = state.cartItems.map(item => {
// //     //                 if(item.cartItemId === cartItem.cartItemId){
// //     //                     return {
// //     //                         ...item,
// //     //                         quantity: product.quantity ? item.quantity + product.quantity : item.quantity + 1
// //     //                     }
// //     //                 }
// //     //                 return item;
// //     //             })
// //     //         }

// //     //     } else {
// //     //         const cartItem = state.cartItems.find(
// //     //             item =>
// //     //                 item.id === product.id &&
// //     //                 product.selectedProductColor &&
// //     //                 product.selectedProductColor === item.selectedProductColor &&
// //     //                 product.selectedProductSize &&
// //     //                 product.selectedProductSize === item.selectedProductSize &&
// //     //                 (product.cartItemId ? product.cartItemId === item.cartItemId : true)
// //     //         );
// //     //         if(!cartItem){
// //     //             state.cartItems.push({
// //     //                 ...product,
// //     //                 quantity: product.quantity ? product.quantity : 1,
// //     //                 cartItemId: uuidv4()
// //     //             });
// //     //         } else if (cartItem !== undefined && (cartItem.selectedProductColor !== product.selectedProductColor || cartItem.selectedProductSize !== product.selectedProductSize)) {
// //     //             state.cartItems = [
// //     //                 ...state.cartItems,
// //     //                 {
// //     //                     ...product,
// //     //                     quantity: product.quantity ? product.quantity : 1,
// //     //                     cartItemId: uuidv4()
// //     //                 }
// //     //             ]
// //     //         } else {
// //     //             state.cartItems = state.cartItems.map(item => {
// //     //                 if(item.cartItemId === cartItem.cartItemId){
// //     //                     return {
// //     //                         ...item,
// //     //                         quantity: product.quantity ? item.quantity + product.quantity : item.quantity + 1,
// //     //                         selectedProductColor: product.selectedProductColor,
// //     //                         selectedProductSize: product.selectedProductSize
// //     //                     }
// //     //                 }
// //     //                 return item;
// //     //             });
// //     //         }
// //     //     }

// //     //     cogoToast.success("Added To Cart", {position: "bottom-left"});
// //     // },
// //     deleteFromCart(state, action) {
// //       state.cartItems = state.cartItems.filter(
// //         (item) => item.cartItemId !== action.payload
// //       );
// //       cogoToast.error("Removed From Cart", { position: "bottom-left" });
// //     },
// //     decreaseQuantity(state, action) {
// //       const product = action.payload;
// //       if (product.quantity === 1) {
// //         state.cartItems = state.cartItems.filter(
// //           (item) => item.cartItemId !== product.cartItemId
// //         );
// //         cogoToast.error("Removed From Cart", { position: "bottom-left" });
// //       } else {
// //         state.cartItems = state.cartItems.map((item) =>
// //           item.cartItemId === product.cartItemId
// //             ? { ...item, quantity: item.quantity - 1 }
// //             : item
// //         );
// //         cogoToast.warn("Item Decremented From Cart", {
// //           position: "bottom-left",
// //         });
// //       }
// //     },
// //     deleteAllFromCart(state) {
// //       state.cartItems = [];
// //     },
// //   },
// // });

// // export const {
// //   addToCart,
// //   setCartItems,
// //   deleteFromCart,
// //   decreaseQuantity,
// //   deleteAllFromCart,
// // } = cartSlice.actions;
// // export default cartSlice.reducer;


// import { v4 as uuidv4 } from 'uuid';
// import cogoToast from 'cogo-toast';
// const { createSlice } = require('@reduxjs/toolkit');
// const cartSlice = createSlice({
//     name: "cart",
//     initialState: {
//         cartItems: []
//     },
//     reducers: {
//         addToCart(state, action) {
//             const product = action.payload;
//             const { id, variation, selectedProductColor = null, selectedProductSize = null } = product;
//             const findMatchingItem = (item) => {
//               const isSameId = item.id === id;
//               const isSameColor = item.selectedProductColor === selectedProductColor;
//               const isSameSize = item.selectedProductSize === selectedProductSize;
//               if (!variation) {
//                 return isSameId;
//               }
//               return isSameId && isSameColor && isSameSize;
//             };
//             const existingItem = state.cartItems.find(findMatchingItem);
//             if (!existingItem) {
//               state.cartItems.push({
//                 ...product,
//                 quantity: product.quantity || 1,
//                 selectedProductColor,
//                 selectedProductSize,
//                 cartItemId: uuidv4()
//               });
//             } else {
//               state.cartItems = state.cartItems.map(item =>
//                 findMatchingItem(item)
//                   ? {
//                       ...item,
//                       quantity: item.quantity + (product.quantity || 1)
//                     }
//                   : item
//               );
//             }
//             cogoToast.success("Added To Cart", { position: "bottom-left" });
//           },
//            setCartItems: (state, action) => {
//       state.cartItems = action.payload;
//     },
//      increaseQuantity(state, action) {
//       const { cartItemId } = action.payload;
//       state.cartItems = state.cartItems.map((item) =>
//         item.cartItemId === cartItemId
//           ? { ...item, quantity: item.quantity + 1 }
//           : item
//       );
//       cogoToast.success("Item Incremented In Cart", { position: "bottom-left" });
//     },
//         // addToCart(state, action) {
//         //     const product = action.payload;
//         //     console.log("Product", product);
//         //     if(!product.variation){
//         //         const cartItem = state.cartItems.find(item => item.id === product.id);
//         //         if(!cartItem){
//         //             state.cartItems.push({
//         //                 ...product,
//         //                 quantity: product.quantity ? product.quantity : 1,
//         //                 cartItemId: uuidv4()
//         //             });
//         //         } else {
//         //             state.cartItems = state.cartItems.map(item => {
//         //                 if(item.cartItemId === cartItem.cartItemId){
//         //                     return {
//         //                         ...item,
//         //                         quantity: product.quantity ? item.quantity + product.quantity : item.quantity + 1
//         //                     }
//         //                 }
//         //                 return item;
//         //             })
//         //         }
//         //     } else {
//         //         const cartItem = state.cartItems.find(
//         //             item =>
//         //                 item.id === product.id &&
//         //                 product.selectedProductColor &&
//         //                 product.selectedProductColor === item.selectedProductColor &&
//         //                 product.selectedProductSize &&
//         //                 product.selectedProductSize === item.selectedProductSize &&
//         //                 (product.cartItemId ? product.cartItemId === item.cartItemId : true)
//         //         );
//         //         if(!cartItem){
//         //             state.cartItems.push({
//         //                 ...product,
//         //                 quantity: product.quantity ? product.quantity : 1,
//         //                 cartItemId: uuidv4()
//         //             });
//         //         } else if (cartItem !== undefined && (cartItem.selectedProductColor !== product.selectedProductColor || cartItem.selectedProductSize !== product.selectedProductSize)) {
//         //             state.cartItems = [
//         //                 ...state.cartItems,
//         //                 {
//         //                     ...product,
//         //                     quantity: product.quantity ? product.quantity : 1,
//         //                     cartItemId: uuidv4()
//         //                 }
//         //             ]
//         //         } else {
//         //             state.cartItems = state.cartItems.map(item => {
//         //                 if(item.cartItemId === cartItem.cartItemId){
//         //                     return {
//         //                         ...item,
//         //                         quantity: product.quantity ? item.quantity + product.quantity : item.quantity + 1,
//         //                         selectedProductColor: product.selectedProductColor,
//         //                         selectedProductSize: product.selectedProductSize
//         //                     }
//         //                 }
//         //                 return item;
//         //             });
//         //         }
//         //     }
//         //     cogoToast.success("Added To Cart", {position: "bottom-left"});
//         // },
//         // deleteFromCart(state, action) {
//         //     state.cartItems = state.cartItems.filter(item => item.cartItemId !== action.payload);
//         //     cogoToast.error("Removed From Cart", {position: "bottom-left"});
//         // },

//         deleteFromCart(state, action) {
//       const cartItemId = action.payload;
//       const itemIndex = state.cartItems.findIndex(item => item.cartItemId === cartItemId);
//       if (itemIndex >= 0) {
//         state.cartItems.splice(itemIndex, 1);
//         cogoToast.error("Removed From Cart", { position: "bottom-left" });
//       }
//     },
//         decreaseQuantity(state, action){
//             const product = action.payload;
//             if (product.quantity === 1) {
//                 state.cartItems = state.cartItems.filter(item => item.cartItemId !== product.cartItemId);
//                 cogoToast.error("Removed From Cart", {position: "bottom-left"});
//             } else {
//                 state.cartItems = state.cartItems.map(item =>
//                     item.cartItemId === product.cartItemId
//                         ? { ...item, quantity: item.quantity - 1 }
//                         : item
//                 );
//                 cogoToast.warn("Item Decremented From Cart", {position: "bottom-left"});
//             }
//         },
//         deleteAllFromCart(state){
//             state.cartItems = []
//         }
//     },
// });
// export const { addToCart,increaseQuantity, deleteFromCart,setCartItems, decreaseQuantity, deleteAllFromCart } = cartSlice.actions;
// export default cartSlice.reducer



import { v4 as uuidv4 } from 'uuid';
import cogoToast from 'cogo-toast';
const { createSlice } = require('@reduxjs/toolkit');
const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartItems: []
  },
  reducers: {
    addToCart(state, action) {
      const product = action.payload;
      const { id, variation, selectedProductColor = null, selectedProductSize = null } = product;
      const findMatchingItem = (item) => {
        const isSameId = item.id === id;
        const isSameColor = item.selectedProductColor === selectedProductColor;
        const isSameSize = item.selectedProductSize === selectedProductSize;
        if (!variation) {
          return isSameId;
        }
        return isSameId && isSameColor && isSameSize;
      };
      const existingItem = state.cartItems.find(findMatchingItem);
      if (!existingItem) {
        state.cartItems.push({
          ...product,
          quantity: product.quantity || 1,
          selectedProductColor,
          selectedProductSize,
          cartItemId: uuidv4() // Ensure a unique ID for each cart entry
        });
      } else {
        state.cartItems = state.cartItems.map(item =>
          findMatchingItem(item)
            ? {
              ...item,
              quantity: item.quantity + (product.quantity || 1)
            }
            : item
        );
      }
      cogoToast.success("Added To Cart", { position: "bottom-left" });
    },
       setCartItems: (state, action) => {
                //  state.cartItems = action.payload;
       state.cartItems = action.payload.map(item =>({
        ...item,
        cartItemId: item.cartItemId || uuidv4()
       }))
        },
    // setCartItems: (state, action) => {
    //   state.cartItems = action.payload;
    // },
    increaseQuantity(state, action) {
      const { cartItemId } = action.payload; // Payload should contain cartItemId
      const itemToUpdate = state.cartItems.find(item => item.cartItemId === cartItemId);
      if (itemToUpdate) {
        itemToUpdate.quantity += 1;
        cogoToast.success("Item Incremented In Cart", { position: "bottom-left" });
      }
    },
    decreaseQuantity(state, action) {
      const { cartItemId } = action.payload; // Payload should contain cartItemId
      const itemToUpdate = state.cartItems.find(item => item.cartItemId === cartItemId);
      if (itemToUpdate && itemToUpdate.quantity > 1) { // Ensure quantity doesn't go below 1
        itemToUpdate.quantity -= 1;
        cogoToast.success("Item Decremented In Cart", { position: "bottom-left" });
      }
    },
    deleteFromCart(state, action) {
      const cartItemIdToDelete = action.payload; // Payload should be the cartItemId
      state.cartItems = state.cartItems.filter(item => item.cartItemId !== cartItemIdToDelete);
      cogoToast.error("Removed From Cart", { position: "bottom-left" });
    },
    deleteAllFromCart(state) {
      state.cartItems = [];
      cogoToast.error("Cart Cleared", { position: "bottom-left" });
    }
  }
});
export const {
  addToCart,
  setCartItems,
  increaseQuantity,
  decreaseQuantity,
  deleteFromCart,
  deleteAllFromCart
} = cartSlice.actions;
export default cartSlice.reducer; 



